import { useState, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ContentWrapper, Textbox, SelectMenu } from 'components/generic';
import { ProfileDetailsContext } from 'providers/profile-provider';
import Images from 'assets/Images';
import { cloneDeep } from 'lodash';
import { getValuesById } from 'utils';

const PaymentDetails = props => {
	const context = useContext(ProfileDetailsContext);
	const { createObj, setCreateObj } = context;
	const [editbutton, setEditButton] = useState({ razorpay: false, paytm: false, bankDetails: false, jiopay: false });
	const referenceData = useSelector(state => state?.referenceData?.data);

	const paymtDtls = createObj?.c_paymentDetails;
	const { c_razorpayCreds, c_paytmCreds, c_bankDetails, c_jiopayCreds } = paymtDtls;

	const handleData = (e, subkey, key) => {
		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			subkey ? (data.c_paymentDetails[key][subkey] = e) : (data.c_paymentDetails[key] = e);
			return data;
		});
	};

	const fetchOnCountry = useMemo(() => {
		const data = getValuesById(referenceData, 'rd_paymentOptions')?.at()?.value;
		return data?.filter(e => e?.allowedCountries?.includes(createObj?.c_country));
	}, [referenceData, createObj]);

	const handleSave = async key => {
		await props.onClickButton({ createObj: key === 'cancel' ? context.originalObj : createObj, key });
		handleButtonClick(null);
	};

	const handleButtonClick = key => {
		setEditButton({ razorpay: false, paytm: false, bankDetails: false, jiopay: false, [key]: true });
	};

	const buttons = (
		<div className='flex-end'>
			<div className='basic-details__button--cancel' onClick={() => handleSave('cancel')}>
				Cancel
			</div>
			<div className='basic-details__button align-center' onClick={() => handleSave('save')}>
				Save
			</div>
		</div>
	);

	const getValueMtpl = (array, data) => {
		const a = [];
		array?.map(el => {
			data?.map(e => {
				el?.key === e && a.push(el);
			});
		});
		return a;
	};

	return (
		<>
			<ContentWrapper shadow>
				<div className='row'>
					<div className='col-5'>
						<SelectMenu
							label='Payment Options'
							multiple
							placeholder='Select'
							menuOptions={fetchOnCountry}
							value={getValueMtpl(getValuesById(referenceData, 'rd_paymentOptions')?.at()?.value, createObj?.c_paymentDetails?.c_paymentOptions)}
							onChange={e => handleData(e, null, 'c_paymentOptions')}
						/>
					</div>
				</div>

				{createObj?.c_paymentDetails?.c_paymentOptions?.includes('c_razorpayCreds') && (
					<div className='basic-details'>
						<div className='space-between'>
							<h4>Razorpay Credentials</h4>
							{!editbutton?.razorpay && (
								<div className='basic-details__button align-center' onClick={() => handleButtonClick('razorpay')}>
									<img src={Images['edit-blue']} /> Edit
								</div>
							)}
						</div>
						<div className='row'>
							<div className='col-5'>
								<Textbox label='Razorpay ID' mandatory placeholder='Enter' display={!editbutton?.razorpay} value={c_razorpayCreds?.c_razorpayID} onChange={e => handleData(e?.target?.value, 'c_razorpayID', 'c_razorpayCreds')} />
							</div>
							<div className='col-5'>
								<Textbox
									label='Razorpay Secret'
									mandatory
									placeholder='Enter'
									display={!editbutton?.razorpay}
									value={c_razorpayCreds?.c_razorpaySecret}
									onChange={e => handleData(e?.target?.value, 'c_razorpaySecret', 'c_razorpayCreds')}
								/>
							</div>
						</div>
						{editbutton?.razorpay && buttons}
					</div>
				)}

				{createObj?.c_paymentDetails?.c_paymentOptions?.includes('c_paytmCreds') && (
					<div className='basic-details'>
						<div className='space-between'>
							<h4>Paytm Credentials</h4>
							{!editbutton?.paytm && (
								<div className='basic-details__button align-center' onClick={() => handleButtonClick('paytm')}>
									<img src={Images['edit-blue']} /> Edit
								</div>
							)}
						</div>
						<div className='row'>
							<div className='col-5'>
								<Textbox label='Merchant ID' mandatory placeholder='Enter' display={!editbutton?.paytm} value={c_paytmCreds?.c_merchantId} onChange={e => handleData(e?.target?.value, 'c_merchantId', 'c_paytmCreds')} />
							</div>
							<div className='col-5'>
								<Textbox label='Merchant Key' mandatory placeholder='Enter' display={!editbutton?.paytm} value={c_paytmCreds?.c_merchantKey} onChange={e => handleData(e?.target?.value, 'c_merchantKey', 'c_paytmCreds')} />
							</div>
						</div>
						{editbutton?.paytm && buttons}
					</div>
				)}

				{createObj?.c_paymentDetails?.c_paymentOptions?.includes('c_bankDetails') && (
					<div className='basic-details'>
						<div className='space-between'>
							<h4>Bank Details</h4>
							{!editbutton?.paytm && (
								<div className='basic-details__button align-center' onClick={() => handleButtonClick('bankDetails')}>
									<img src={Images['edit-blue']} /> Edit
								</div>
							)}
						</div>
						<div className='row'>
							<div className='col-5'>
								<Textbox label='Account Number' mandatory placeholder='Enter' display={!editbutton?.bankDetails} value={c_bankDetails?.c_accountNo} onChange={e => handleData(e?.target?.value, 'c_accountNo', 'c_bankDetails')} />
							</div>
							<div className='col-5'>
								<Textbox label='Account Name' mandatory placeholder='Enter' display={!editbutton?.bankDetails} value={c_bankDetails?.c_accountName} onChange={e => handleData(e?.target?.value, 'c_accountName', 'c_bankDetails')} />
							</div>
							<div className='col-5'>
								<Textbox label='Bank Name' mandatory placeholder='Enter' display={!editbutton?.bankDetails} value={c_bankDetails?.c_bankName} onChange={e => handleData(e?.target?.value, 'c_bankName', 'c_bankDetails')} />
							</div>
							<div className='col-5'>
								<Textbox label='IFSC Code' mandatory placeholder='Enter' display={!editbutton?.bankDetails} value={c_bankDetails?.c_ifscCode} onChange={e => handleData(e?.target?.value, 'c_ifscCode', 'c_bankDetails')} />
							</div>
							<div className='col-5'>
								<Textbox label='BSB Number' placeholder='Enter' display={!editbutton?.bankDetails} value={c_bankDetails?.c_bsbNumber} onChange={e => handleData(e?.target?.value, 'c_bsbNumber', 'c_bankDetails')} />
							</div>
							<div className='col-5'>
								<Textbox label='Remitter Name' placeholder='Enter' display={!editbutton?.bankDetails} value={c_bankDetails?.c_remitterName} onChange={e => handleData(e?.target?.value, 'c_remitterName', 'c_bankDetails')} />
							</div>
						</div>
						{editbutton?.bankDetails && buttons}
					</div>
				)}

				{createObj?.c_paymentDetails?.c_paymentOptions?.includes('c_jiopayCreds') && (
					<div className='basic-details'>
						<div className='space-between'>
							<h4>Jiopay Credentials</h4>
							{!editbutton?.jiopay && (
								<div className='basic-details__button align-center' onClick={() => handleButtonClick('jiopay')}>
									<img src={Images['edit-blue']} /> Edit
								</div>
							)}
						</div>
						<div className='row'>
							<div className='col-5'>
								<Textbox label='Merchant ID' mandatory placeholder='Enter' display={!editbutton?.jiopay} value={c_jiopayCreds?.c_merchantId} onChange={e => handleData(e?.target?.value, 'c_merchantId', 'c_jiopayCreds')} />
							</div>
							<div className='col-5'>
								<Textbox label='Secret Key' mandatory placeholder='Enter' display={!editbutton?.jiopay} value={c_jiopayCreds?.c_SecretKey} onChange={e => handleData(e?.target?.value, 'c_SecretKey', 'c_jiopayCreds')} />
							</div>
							<div className='col-5'>
								<Textbox label='Client ID' mandatory placeholder='Enter' display={!editbutton?.jiopay} value={c_jiopayCreds?.c_clientId} onChange={e => handleData(e?.target?.value, 'c_clientId', 'c_jiopayCreds')} />
							</div>
						</div>
						{editbutton?.jiopay && buttons}
					</div>
				)}

			</ContentWrapper>
		</>
	);
};

export default PaymentDetails;
